/**
 * FloatingOrbs - Animated gradient orbs floating in the background
 *
 * Creates ambient visual interest with slowly moving gradient orbs.
 */

"use client";

import { motion, useReducedMotion } from "framer-motion";

const orbs = [
  {
    className:
      "absolute -top-40 -left-40 w-[550px] h-[550px] rounded-full bg-gradient-to-br from-pink-500/8 to-purple-500/8 blur-[90px]",
    animate: { x: [0, 40, -25, 0], y: [0, -30, 15, 0] },
    duration: 20,
    delay: 0,
  },
  {
    className:
      "absolute top-1/3 -right-40 w-[450px] h-[450px] rounded-full bg-gradient-to-br from-purple-500/8 to-pink-500/8 blur-[90px]",
    animate: { x: [0, -35, 20, 0], y: [0, 20, -30, 0] },
    duration: 25,
    delay: 3,
  },
];

export default function FloatingOrbs() {
  const shouldReduceMotion = useReducedMotion();

  if (shouldReduceMotion) {
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {orbs.map((orb, index) => (
          <div key={index} className={orb.className} />
        ))}
      </div>
    );
  }

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {orbs.map((orb, index) => (
        <motion.div
          key={index}
          className={orb.className}
          animate={orb.animate}
          transition={{
            duration: orb.duration,
            delay: orb.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}
    </div>
  );
}
